require('./brokerStocksContractTAC.scss');

const PropTypes = require('prop-types');

// @ vendors
const React = require('react');
// @ components
const { formatText } = require('core/i18n').i18n;
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { OKLink } = require('commonsComponents/OKLink');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
// @ constants
const { CONTRATO_PRESTACION_SERVICIOS_PERSONAS_FISICAS } = require('constants/index');

const WebappRender = require('components/conditionalRender/webappRender')
class BrokerStocksContractTAC extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            disclaimerChecked: false
        }
        this.handleOnChange = this.handleOnChange.bind(this);
        this.buildCheckboxLabel = this.buildCheckboxLabel.bind(this);
    }

    buildCheckboxLabel() {
        const tacText2 = formatText('broker-stocksContractTACText2');
        const tacText4 = formatText('broker-stocksContractTACText4');
        const preContractInfoTarget = !__CONTACT_CENTER__ ? "_blank" : null;
        const preContratoLink = __CONTACT_CENTER__ ? (<OKLink
            modifier="emphasize"
            to="/myprofile/broker/preContractInfo"
            target={preContractInfoTarget}
            >{tacText2}</OKLink>) : tacText2;
        const contratoPrestacionesServiciosLink = __CONTACT_CENTER__ ? (<OKLink
            modifier="emphasize"
            to={CONTRATO_PRESTACION_SERVICIOS_PERSONAS_FISICAS}
            target={preContractInfoTarget}
            className="stocks-contract-tac__text-link">{tacText4}</OKLink>) : tacText4;
        const arrayLinks = [preContratoLink, contratoPrestacionesServiciosLink]

        return (
            <span className="stocks-contract-tac__text">
                <FormattedTextWithComponents
                    value="broker-stocksContractTACComplete"
                    injectedComponents={arrayLinks}
                />
            </span>
        )
    }

    handleOnChange(evt) {
        this.setState({
            disclaimerChecked: evt.target.checked
        });
        this.props.onChange({
            checked: evt.target.checked
        });
    }

    render() {
        const {
            disclaimerErrorMessage,
            disclaimerErrorState,
            disabled
        } = this.props;

        const { disclaimerChecked } = this.state;

        return (
            <WebappRender>
                <OKCheckbox
                    extraClass="stocks-contract-tac"
                    idName="tac"
                    onChange={this.handleOnChange}
                    errorState={disclaimerErrorState}
                    errorMessage={disclaimerErrorMessage}
                    label={this.buildCheckboxLabel()}
                    value={disclaimerChecked}
                    disabled={disabled}
                />
            </WebappRender>
        );
    }
}

BrokerStocksContractTAC.propTypes = {
    disabled: PropTypes.bool,
    disclaimerErrorMessage: PropTypes.String,
    disclaimerErrorState: PropTypes.bool,
    onChange: PropTypes.func,
    contractServicesIndividuals: PropTypes.string,
};

BrokerStocksContractTAC.defaultProps = {
    onChange: function() {},
    disabled: false,
}

module.exports = BrokerStocksContractTAC;
